import {NavigationEntityState, DropPosition} from '~ui/store/slices/navigation-tree';

import {isInnerDrop} from './is-inner-drop';

// get position data must also account for the virtual slug
export function getPositionData(
    entities: Record<string, NavigationEntityState>,
    targetItem: NavigationEntityState,
    position: DropPosition,
) {
    if (isInnerDrop(targetItem, position)) {
        const firstChildSlug = targetItem.children[0];

        const page = firstChildSlug ? entities[firstChildSlug] : undefined;

        if (!page) return {};

        return {
            nextToSlug: page.virtualSlug || page.slug,
            position: 'before' as const,
        };
    }

    const targetPositionItemSlug = targetItem.virtualSlug || targetItem.slug;

    if (position === 'bottom') {
        return {
            nextToSlug: targetPositionItemSlug,
            position: 'after' as const,
        };
    }

    return {
        nextToSlug: targetPositionItemSlug,
        position: 'before' as const,
    };
}
